// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";
import Headroom from "headroom.js";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

import "./slider-news.scss";
const sliderNews = () => {
    let allSliderNews = document.querySelectorAll(".slider-news");

    if (!allSliderNews.length) return;

    allSliderNews.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            breakpoints: {
                0: { spaceBetween: 16, slidesPerView: 1.1 },
                500: { spaceBetween: 16, slidesPerView: 1.7 },
                768: { spaceBetween: 30, slidesPerView: 2.1 },
                800: { spaceBetween: 30, slidesPerView: 2.5 },
                1222: { spaceBetween: 30, slidesPerView: 3.3 },
                1500: { spaceBetween: 30, slidesPerView: 4 },
            },
            spaceBetween: 30,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

import "./slider-cards-text-on-bg.scss";
const sliderCardsTextOnBg = () => {
    let allSliderCardsTextOnBg = document.querySelectorAll(
        ".slider-cards-text-on-bg"
    );

    if (!allSliderCardsTextOnBg.length) return;

    allSliderCardsTextOnBg.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            breakpoints: {
                0: { spaceBetween: 16, slidesPerView: 1.1 },
                500: { spaceBetween: 16, slidesPerView: 1.7 },
                768: { spaceBetween: 30, slidesPerView: 2.1 },
                800: { spaceBetween: 30, slidesPerView: 2.5 },
                1222: { spaceBetween: 30, slidesPerView: 3.3 },
                1500: { spaceBetween: 30, slidesPerView: 4 },
            },
            spaceBetween: 30,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

const initSliders = () => {
    sliderNews();
    sliderCardsTextOnBg();
};

export default initSliders;
